import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

export type RttStatus = 'STARTING' | 'ACTIVE' | 'STOPPED' | 'ERROR';

export type RttResponse = { channel: string; status: RttStatus; agentId?: string };

export type RttRequest = { channel: string; eventId: number };

export const agoraApi = createApi({
  reducerPath: 'agoraApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    startRtt: builder.mutation<RttResponse, RttRequest>({
      query: (data) => ({ url: '/agora/rtt/start', method: 'POST', data }),
    }),
    stopRtt: builder.mutation<RttResponse, RttRequest>({
      query: (data) => ({ url: '/agora/rtt/stop', method: 'POST', data }),
    }),
  }),
});

export const { useStartRttMutation, useStopRttMutation } = agoraApi;
